import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function DaiIcon({
  width = 50,
  height = 50,
  fill = 'white',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill={fill}
      {...props}
    >
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <path
        d="M15.442 15.847h4.56c.097 0 .143 0 .15-.127.037-.464.037-.93 0-1.395 0-.09-.045-.127-.142-.127h-9.075c-.113 0-.143.037-.143.142v1.335c0 .172 0 .172.18.172h4.47zm4.2-3.21a.146.146 0 000-.104 2.959 2.959 0 00-.27-.473 3.828 3.828 0 00-.555-.697c-.1-.127-.216-.241-.345-.338a5.39 5.39 0 00-2.25-1.14 5.593 5.593 0 00-1.276-.135H10.92c-.112 0-.127.045-.127.143v2.662c0 .112 0 .143.142.143h8.655s.075-.016.09-.06h-.037zm0 4.77a1.755 1.755 0 00-.383 0h-8.317c-.112 0-.15 0-.15.15v2.603c0 .12 0 .15.15.15h3.84c.184.015.367.002.547-.037a5.72 5.72 0 001.628-.36c.19-.066.374-.152.547-.255h.053a4.873 4.873 0 002.092-2.106s.053-.114-.006-.143v-.002zM9.286 21.66v-4.147c0-.098 0-.113-.12-.113H7.538c-.09 0-.128 0-.128-.12v-1.425h1.74c.097 0 .135 0 .135-.127v-1.41c0-.09 0-.112-.12-.112H7.538c-.09 0-.128 0-.128-.12v-1.32c0-.082 0-.105.12-.105h1.612c.113 0 .143 0 .143-.142V8.476c0-.12 0-.15.15-.15h5.625a8.57 8.57 0 011.215.135 7.331 7.331 0 012.347.87c.482.284.925.626 1.32 1.02.297.308.565.642.802.998.236.36.433.745.586 1.147.02.105.12.176.225.158h1.342c.172 0 .172 0 .18.165v1.23c0 .12-.045.15-.165.15h-1.036c-.104 0-.135 0-.127.135a7.65 7.65 0 010 1.372c0 .128 0 .143.143.143h1.184c.053.067 0 .135 0 .203.008.087.008.175 0 .262v.908c0 .127-.037.165-.15.165H21.51a.188.188 0 00-.218.142 5.997 5.997 0 01-1.575 2.296c-.255.229-.523.445-.803.644-.3.173-.592.353-.9.495a8.112 8.112 0 01-1.77.563 9.226 9.226 0 01-1.755.142H9.283v-.007l.002-.002z"
        fill="#F5AC37"
      />
    </svg>
  );
}

const MemoDaiIcon = React.memo(DaiIcon);
export default MemoDaiIcon;
